import React from 'react';
import styles from './AccordionHeader.module.scss';

interface Props {
  children: JSX.Element | JSX.Element[] | string;
  className?: string;
}

const AccordionContent = ({ children, className = '' }: Props) => {
  const classes = [styles.AccordionControls];
  if (className) classes.push(className);
  // This is wrapped in a span instead of a div to prevent
  // triggering the focus ring on the accordion group as it
  // uses a has:() selector
  return <span className={classes.join(' ')}>{children}</span>;
};

export default AccordionContent;
